export const translations = {
  en: {
    wishlist: "Wishlu", family: "Family", myList: "My Wishlu", signOut: "Sign out",
    signIn: "Sign in", join: "Join", giftWishlists: "Wishlus",
    tapMember: "Tap on a family member to see their Wishlu",
    noMembers: "No members yet", beFirst: "Be the first to join",
    gifts: "gifts", back: "← Back", pdf: "PDF", addGift: "+ Add gift",
    shareList: "Share this Wishlu with someone outside the family:",
    inviteMembers: "Invite family members",
    copy: "Copy", linkCopied: "Link copied!", emptyList: "Empty Wishlu",
    addFirst: "Add your first gift above", noGifts: "No gifts added yet",
    addAGift: "Add a gift", editGift: "Edit gift", photoRequired: "Only the photo is required",
    giftName: "Gift name", giftNamePlaceholder: "e.g. Leather bag",
    purchaseLink: "Purchase link", description: "Description (size, color, notes)",
    descPlaceholder: "e.g. Size M, black or camel", photo: "Photo — required",
    tapPhoto: "Tap to upload a photo", changePhoto: "Change photo",
    uploading: "Uploading...", saveChanges: "Save changes", cancel: "Cancel",
    welcomeBack: "Welcome back", signInToEdit: "Sign in to edit your Wishlu",
    email: "Email", password: "Password", incorrectCredentials: "Incorrect email or password",
    createAccount: "Create a new account", joinFamily: "Join the family",
    createWishlist: "Create your Wishlu", yourName: "Your name",
    namePlaceholder: "e.g. Sarah", atLeast6: "at least 6 characters",
    profileColor: "Your profile color", preview: "Preview",
    birthday: "Birthday (optional, DD/MM/YYYY)", createMyList: "Create my Wishlu", signUp: "Sign up",
    alreadyHaveAccount: "I already have an account", emailInUse: "This email is already registered",
    weakPassword: "Password must be at least 6 characters", signUpFailed: "Sign up failed. Please try again.",
    fillFields: "Please fill in all required fields", language: "Language",
    familyName: "Family name", familyNamePlaceholder: "e.g. The Smiths",
    welcomeLeader: "Welcome! You are the family leader 👑",
    welcome: "Welcome", seeYouSoon: "See you soon!", giftAdded: "Gift added!",
    giftUpdated: "Gift updated!", giftRemoved: "Gift removed", photoNeeded: "A photo is required",
    errorSaving: "Error saving gift. Try again.", generatingPDF: "Generating PDF...",
    pdfDownloaded: "PDF downloaded!", errorPDF: "Error generating PDF",
    familySaved: "Family name saved!", illBuyThis: "I'll buy this", unmark: "Unmark",
    alreadyPurchased: "✅ Already purchased", committed: "Reserved", purchased: "Purchased", viewProduct: "View product →",
    markedPurchased: "Marked as purchased!", markedNotPurchased: "Marked as not purchased", markedAvailable: "Marked as available",
    markNotPurchased: "Mark as not purchased", invalidPrice: "Enter a valid price",
    personalPriceSaved: "Personal price saved",
    signInToBuy: "Sign in to reserve", edit: "Edit", delete: "Delete",
    wishlistChoice: "Which Wishlu do you want to use in this group?",
    useExisting: "Use my existing Wishlu", createNew: "Create a new Wishlu",
    wishlistName: "Wishlu name", wishlistNamePlaceholder: "e.g. Christmas 2025",
    confirm: "Confirm", save: "Save", close: "Close",
    joiningFamily: "Joining family...", listNotFound: "Wishlu not found.",
    loading: "Loading...", onTheirList: "gifts on their Wishlu",
    noGiftsForPDF: "No gifts to generate PDF",
    editFamilyName: "Edit family name",
    welcomeToFamily: "You've been invited to join",
    joinNow: "Create account", alreadyMember: "Sign in",
    createNewGroup: "Create new group", signOutMenu: "Sign out", myGroups: "My groups",
    keepMyList: "Keep my current Wishlu", createNewList: "Create a new Wishlu for this group",
    addManagedMember: "Manage someone else's Wishlu",
    addManagedMemberDesc: "Add a person without an account (e.g. your child). You'll control their Wishlu.",
    managedMemberName: "Their name",
    managedMemberNamePlaceholder: "e.g. Emma",
    addMember: "Add",
    managedBadge: "Managed by you",
    deleteConfirm: "Delete this gift?",
    deleteManaged: "Remove from group",
    deleteManagedConfirm: "Remove this person and their Wishlu from the group?",
    editManaged: "Edit",
    birthdayNotifications: "Birthday email reminders",
    notificationsOn: "On",
    notificationsOff: "Off",
    darkMode: "Dark mode",
    santaSecretTitle: "Secret Santa",
    santaSecretToggle: "Secret Santa",
    santaSecretConfirm: "Is everyone already in the group?",
    santaSecretYes: "Yes, assign Secret Santas!",
    santaSecretCancel: "Not yet",
    santaSecretActive: "Secret Santa is active 🎅",
    santaSecretDeactivate: "Deactivate",
    santaSecretReveal: "🎁 Open your envelope",
    santaSecretYouGot: "You have Secret Santa for:",
    santaSecretBudget: "Suggested budget",
    santaSecretNoBudget: "No limit",
    santaSecretNotEnough: "You need at least 2 members to activate Secret Santa",
    santaSecretNotification: "🎅 Secret Santa has been activated! Open your envelope to find out who you're gifting.",
    lazyLoadMore: "Load more",
    orderBy: "Sort by",
    orderByDate: "Default",
    orderByName: "Name",
    orderByPrice: "Price: low to high",
    price: "Price (optional)",
    pricePlaceholder: "e.g. 29.99",
    editProfile: "Edit profile",
    saveProfile: "Save profile",
    groupOptions: "Group options",
    leaveGroup: "Leave group",
    leaveGroupConfirm: "Leave this group?",
    deleteGroup: "Delete group",
    deleteGroupConfirm: "Delete this group permanently?",
    removeMember: "Remove member",
    removeMemberConfirm: "Remove {name} from the group?",
    memberRemoved: "{name} removed",
    changeGroupIcon: "Change group icon",
    groupIconLabel: "Choose an icon for this group (only you see it)",
    currency: "Currency", currencyLabel: "Your currency",
    budgetTitle: "My budget", budgetSet: "Set budget",
    budgetTotal: "Total budget", budgetCommitted: "Committed",
    budgetSpent: "Spent", budgetAvailable: "Available",
    budgetPlaceholder: "e.g. 500", budgetSaved: "Budget saved!",
    budgetNone: "No budget set", setBudget: "Set budget",
    budgetGeneral: "General expenses",
    memberSortLabel: "Sort members", memberSortRegDate: "Registration date",
    memberSortName: "Name A-Z", memberSortBirthday: "Upcoming birthday",
    photoOptional: "Photo is optional",
    pendingLabel: "Pending", purchasedLabel: "Purchased",
    wishluTab: "My Wishlu", groupsTab: "Groups", profileTab: "Profile",
  },
  es: {
    wishlist: "Wishlu", family: "Familia", myList: "Mi Wishlu", signOut: "Salir",
    signIn: "Iniciar sesión", join: "Unirse", giftWishlists: "Wishlus",
    tapMember: "Toca a un miembro para ver su Wishlu",
    noMembers: "Aún no hay miembros", beFirst: "Sé el primero en unirte",
    gifts: "regalos", back: "← Volver", pdf: "PDF", addGift: "+ Agregar regalo",
    shareList: "Comparte esta Wishlu con alguien fuera de la familia:",
    inviteMembers: "Invitar miembros a la familia",
    copy: "Copiar", linkCopied: "¡Link copiado!", emptyList: "Wishlu vacía",
    addFirst: "Agrega tu primer regalo arriba", noGifts: "Aún no hay regalos",
    addAGift: "Agregar regalo", editGift: "Editar regalo", photo: "Foto — obligatoria",
    giftName: "Nombre del regalo", giftNamePlaceholder: "ej. Bolsa de piel",
    purchaseLink: "Link de compra", description: "Descripción (talla, color, notas)",
    descPlaceholder: "ej. Talla M, negro o camel",
    tapPhoto: "Toca para subir una foto", changePhoto: "Cambiar foto",
    uploading: "Subiendo...", saveChanges: "Guardar cambios", cancel: "Cancelar",
    welcomeBack: "Bienvenido de vuelta", signInToEdit: "Inicia sesión para editar tu Wishlu",
    email: "Correo electrónico", password: "Contraseña", incorrectCredentials: "Correo o contraseña incorrectos",
    createAccount: "Crear nueva cuenta", joinFamily: "Únete a la familia",
    createWishlist: "Crea tu Wishlu", yourName: "Tu nombre",
    namePlaceholder: "ej. Luisana", atLeast6: "mínimo 6 caracteres",
    profileColor: "Tu color de perfil", preview: "Vista previa",
    birthday: "Cumpleaños (opcional, DD/MM/AAAA)", createMyList: "Crear mi Wishlu", signUp: "Registrarse",
    alreadyHaveAccount: "Ya tengo cuenta", emailInUse: "Este correo ya está registrado",
    weakPassword: "La contraseña debe tener al menos 6 caracteres", signUpFailed: "Error al registrarse. Intenta de nuevo.",
    fillFields: "Por favor llena todos los campos requeridos", language: "Idioma",
    familyName: "Nombre de la familia", familyNamePlaceholder: "ej. Los García",
    welcomeLeader: "¡Bienvenido! Eres el líder de la familia 👑",
    welcome: "¡Bienvenido", seeYouSoon: "¡Hasta pronto!", giftAdded: "¡Regalo agregado!",
    giftUpdated: "¡Regalo actualizado!", giftRemoved: "Regalo eliminado", photoNeeded: "La foto es obligatoria",
    errorSaving: "Error al guardar. Intenta de nuevo.", generatingPDF: "Generando PDF...",
    pdfDownloaded: "¡PDF descargado!", errorPDF: "Error al generar el PDF",
    familySaved: "¡Nombre guardado!", illBuyThis: "Yo lo compro", unmark: "Desmarcar",
    alreadyPurchased: "✅ Ya fue comprado", viewProduct: "Ver producto →",
    markedPurchased: "¡Marcado como comprado!", markedNotPurchased: "Marcado como no comprado", markedAvailable: "Marcado como disponible",
    markNotPurchased: "Marcar como no comprado", invalidPrice: "Ingresa un precio válido",
    personalPriceSaved: "Precio personal guardado",
    committed: "Reservado", purchased: "Comprado",
    signInToBuy: "Inicia sesión para reservar", edit: "Editar", delete: "Eliminar",
    wishlistChoice: "¿Qué Wishlu quieres usar en este grupo?",
    useExisting: "Usar mi Wishlu actual", createNew: "Crear una Wishlu nueva",
    wishlistName: "Nombre de la Wishlu", wishlistNamePlaceholder: "ej. Navidad 2025",
    confirm: "Confirmar", save: "Guardar", close: "Cerrar",
    joiningFamily: "Uniéndose a la familia...", listNotFound: "Wishlu no encontrada.",
    loading: "Cargando...", onTheirList: "regalos en su Wishlu",
    noGiftsForPDF: "No hay regalos para generar PDF",
    editFamilyName: "Editar nombre de familia",
    welcomeToFamily: "Te han invitado a unirte a",
    joinNow: "Crear cuenta", alreadyMember: "Iniciar sesión",
    createNewGroup: "Crear nuevo grupo", signOutMenu: "Salir", myGroups: "Mis grupos",
    keepMyList: "Usar mi Wishlu actual", createNewList: "Crear una Wishlu nueva para este grupo",
    addManagedMember: "Manejar la Wishlu de otra persona",
    addManagedMemberDesc: "Agrega a alguien sin cuenta (ej. tu hijo/a). Tú controlarás su Wishlu.",
    managedMemberName: "Su nombre",
    managedMemberNamePlaceholder: "ej. Emma",
    addMember: "Agregar",
    managedBadge: "Gestionado por ti",
    deleteConfirm: "¿Eliminar este regalo?",
    deleteManaged: "Quitar del grupo",
    deleteManagedConfirm: "¿Quitar a esta persona y su Wishlu del grupo?",
    editManaged: "Editar",
    birthdayNotifications: "Recordatorios de cumpleaños por email",
    notificationsOn: "Activados",
    notificationsOff: "Desactivados",
    darkMode: "Modo nocturno",
    santaSecretTitle: "Santa Secreto",
    santaSecretToggle: "Santa Secreto",
    santaSecretConfirm: "¿Ya están todos los miembros en la Wishlu?",
    santaSecretYes: "¡Sí, asignar Santa Secreto!",
    santaSecretCancel: "Aún no",
    santaSecretActive: "Santa Secreto está activo 🎅",
    santaSecretDeactivate: "Desactivar",
    santaSecretReveal: "🎁 Abrir mi sobre",
    santaSecretYouGot: "Tu Santa Secreto es para:",
    santaSecretBudget: "Presupuesto sugerido",
    santaSecretNoBudget: "Sin límite",
    santaSecretNotEnough: "Necesitas al menos 2 miembros para activar Santa Secreto",
    santaSecretNotification: "🎅 ¡Santa Secreto ha sido activado! Abre tu sobre para saber a quién le vas a regalar.",
    lazyLoadMore: "Cargar más",
    orderBy: "Ordenar por",
    orderByDate: "Predeterminado",
    orderByName: "Nombre",
    orderByPrice: "Precio: menor a mayor",
    price: "Precio (opcional)",
    pricePlaceholder: "ej. 29.99",
    editProfile: "Editar perfil",
    saveProfile: "Guardar perfil",
    groupOptions: "Opciones del grupo",
    leaveGroup: "Salirse del grupo",
    leaveGroupConfirm: "¿Salirse de este grupo?",
    deleteGroup: "Eliminar grupo",
    deleteGroupConfirm: "¿Eliminar este grupo permanentemente?",
    removeMember: "Eliminar miembro",
    removeMemberConfirm: "¿Eliminar a {name} del grupo?",
    memberRemoved: "{name} eliminado",
    changeGroupIcon: "Cambiar icono del grupo",
    groupIconLabel: "Elige un icono para este grupo (solo tú lo ves)",
    currency: "Moneda", currencyLabel: "Tu moneda",
    budgetTitle: "Mi presupuesto", budgetSet: "Definir presupuesto",
    budgetTotal: "Presupuesto total", budgetCommitted: "Comprometido",
    budgetSpent: "Gastado", budgetAvailable: "Disponible",
    budgetPlaceholder: "ej. 500", budgetSaved: "¡Presupuesto guardado!",
    budgetNone: "Sin presupuesto definido", setBudget: "Definir presupuesto",
    budgetGeneral: "Gastos en general",
    memberSortLabel: "Ordenar miembros", memberSortRegDate: "Fecha de registro",
    memberSortName: "Nombre A-Z", memberSortBirthday: "Cumpleaños próximo",
    photoOptional: "La foto es opcional",
    pendingLabel: "Pendiente", purchasedLabel: "Comprado",
    wishluTab: "Mi Wishlu", groupsTab: "Grupos", profileTab: "Perfil",
  },
  fi: {
    wishlist: "Wishlu", family: "Perhe", myList: "Oma Wishlu", signOut: "Kirjaudu ulos",
    signIn: "Kirjaudu sisään", join: "Liity", giftWishlists: "Wishlut",
    tapMember: "Napauta jäsentä nähdäksesi hänen Wishlu",
    noMembers: "Ei jäseniä vielä", beFirst: "Ole ensimmäinen",
    gifts: "lahjaa", back: "← Takaisin", pdf: "PDF", addGift: "+ Lisää lahja",
    shareList: "Jaa tämä Wishlu perheen ulkopuoliselle:",
    inviteMembers: "Kutsu perheenjäseniä",
    copy: "Kopioi", linkCopied: "Linkki kopioitu!", emptyList: "Tyhjä Wishlu",
    addFirst: "Lisää ensimmäinen lahjasi yllä", noGifts: "Ei lahjoja vielä",
    addAGift: "Lisää lahja", editGift: "Muokkaa lahjaa", photoRequired: "Vain kuva on pakollinen",
    giftName: "Lahjan nimi", giftNamePlaceholder: "esim. Nahkalaukku",
    purchaseLink: "Ostolinkki", description: "Kuvaus (koko, väri, huomiot)",
    descPlaceholder: "esim. Koko M, musta tai kameli", photo: "Kuva — pakollinen",
    tapPhoto: "Napauta ladataksesi kuvan", changePhoto: "Vaihda kuva",
    uploading: "Ladataan...", saveChanges: "Tallenna muutokset", cancel: "Peruuta",
    welcomeBack: "Tervetuloa takaisin", signInToEdit: "Kirjaudu muokataksesi Wishluasi",
    email: "Sähköposti", password: "Salasana", incorrectCredentials: "Väärä sähköposti tai salasana",
    createAccount: "Luo uusi tili", joinFamily: "Liity perheeseen",
    createWishlist: "Luo oma Wishlu", yourName: "Nimesi",
    namePlaceholder: "esim. Matti", atLeast6: "vähintään 6 merkkiä",
    profileColor: "Profiiliväri", preview: "Esikatselu",
    birthday: "Syntymäpäivä (valinnainen, PP/KK/VVVV)", createMyList: "Luo Wishlu", signUp: "Rekisteröidy",
    alreadyHaveAccount: "Minulla on jo tili", emailInUse: "Tämä sähköposti on jo rekisteröity",
    weakPassword: "Salasanan on oltava vähintään 6 merkkiä", signUpFailed: "Rekisteröinti epäonnistui.",
    fillFields: "Täytä kaikki pakkolliset kentät", language: "Kieli",
    familyName: "Perheen nimi", familyNamePlaceholder: "esim. Virtasen perhe",
    welcomeLeader: "Tervetuloa! Olet perheen johtaja 👑",
    welcome: "Tervetuloa", seeYouSoon: "Nähdään pian!", giftAdded: "Lahja lisätty!",
    giftUpdated: "Lahja päivitetty!", giftRemoved: "Lahja poistettu", photoNeeded: "Kuva on pakollinen",
    errorSaving: "Virhe tallennuksessa. Yritä uudelleen.", generatingPDF: "Luodaan PDF...",
    pdfDownloaded: "PDF ladattu!", errorPDF: "Virhe PDF:n luomisessa",
    familySaved: "Nimi tallennettu!", illBuyThis: "Minä ostan tämän", unmark: "Peruuta merkintä",
    alreadyPurchased: "✅ Jo ostettu", viewProduct: "Näytä tuote →",
    markedPurchased: "Merkitty ostetuksi!", markedNotPurchased: "Merkitty ostamattomaksi", markedAvailable: "Merkitty saatavilla olevaksi",
    markNotPurchased: "Merkitse ostamattomaksi", invalidPrice: "Anna kelvollinen hinta",
    personalPriceSaved: "Oma hinta tallennettu",
    committed: "Varattu", purchased: "Ostettu",
    signInToBuy: "Kirjaudu varataksesi", edit: "Muokkaa", delete: "Poista",
    wishlistChoice: "Mitä Wishluasi haluat käyttää tässä ryhmässä?",
    useExisting: "Käytä nykyistä Wishluani", createNew: "Luo uusi Wishlu",
    wishlistName: "Wishlu nimi", wishlistNamePlaceholder: "esim. Joulu 2025",
    confirm: "Vahvista", save: "Tallenna", close: "Sulje",
    joiningFamily: "Liitytään perheeseen...", listNotFound: "Wishluasi ei löydy.",
    loading: "Ladataan...", onTheirList: "lahjaa Wishlussa",
    noGiftsForPDF: "Ei lahjoja PDF:n luomiseen",
    editFamilyName: "Muokkaa perheen nimeä",
    welcomeToFamily: "Sinut on kutsuttu liittymään",
    joinNow: "Luo tili", alreadyMember: "Kirjaudu sisään",
    createNewGroup: "Luo uusi ryhmä", signOutMenu: "Kirjaudu ulos", myGroups: "Omat ryhmät",
    keepMyList: "Pidä nykyinen Wishlu", createNewList: "Luo uusi Wishlu tähän ryhmään",
    addManagedMember: "Hallinnoi toisen henkilön Wishluia",
    addManagedMemberDesc: "Lisää henkilö ilman tiliä (esim. lapsesi). Sinä hallinnoit hänen Wishluaan.",
    managedMemberName: "Hänen nimensä", managedMemberNamePlaceholder: "esim. Emma",
    addMember: "Lisää", managedBadge: "Sinun hallinnoima",
    deleteConfirm: "Poista tämä lahja?",
    deleteManaged: "Poista ryhmästä", deleteManagedConfirm: "Poistetaanko tämä henkilö ja hänen Wishlu ryhmästä?",
    editManaged: "Muokkaa",
    birthdayNotifications: "Syntymäpäivämuistutukset sähköpostitse",
    notificationsOn: "Päällä", notificationsOff: "Pois päältä",
    darkMode: "Yötila",
    santaSecretTitle: "Salainen Joulupukki",
    santaSecretToggle: "Salainen Joulupukki",
    santaSecretConfirm: "Ovatko kaikki jäsenet jo Wishlussa?",
    santaSecretYes: "Kyllä, arvotaan Salainen Joulupukki!",
    santaSecretCancel: "Ei vielä",
    santaSecretActive: "Salainen Joulupukki on aktiivinen 🎅",
    santaSecretDeactivate: "Poista käytöstä",
    santaSecretReveal: "🎁 Avaa kirjekuoresi",
    santaSecretYouGot: "Sinun Salainen Joulupukkisi on:",
    santaSecretBudget: "Suositeltu budjetti",
    santaSecretNoBudget: "Ei rajaa",
    santaSecretNotEnough: "Tarvitset vähintään 2 jäsentä Salaisen Joulupukin aktivoimiseksi",
    santaSecretNotification: "🎅 Salainen Joulupukki on aktivoitu! Avaa kirjekuoresi nähdäksesi kenelle lahjoitat.",
    lazyLoadMore: "Lataa lisää",
    orderBy: "Järjestä",
    orderByDate: "Oletus",
    orderByName: "Nimi",
    orderByPrice: "Hinta: halvimmasta",
    price: "Hinta (valinnainen)",
    pricePlaceholder: "esim. 29.99",
    editProfile: "Muokkaa profiilia",
    saveProfile: "Tallenna profiili",
    groupOptions: "Ryhmän asetukset",
    leaveGroup: "Poistu ryhmästä",
    leaveGroupConfirm: "Poistu tästä ryhmästä?",
    deleteGroup: "Poista ryhmä",
    deleteGroupConfirm: "Poista tämä ryhmä pysyvästi?",
    removeMember: "Poista jäsen",
    removeMemberConfirm: "Poistetaanko {name} ryhmästä?",
    memberRemoved: "{name} poistettu",
    changeGroupIcon: "Vaihda ryhmän kuvake",
    groupIconLabel: "Valitse kuvake tälle ryhmälle (vain sinä näet sen)",
    currency: "Valuutta", currencyLabel: "Oma valuuttasi",
    budgetTitle: "Budjettini", budgetSet: "Aseta budjetti",
    budgetTotal: "Kokonaisbudjetti", budgetCommitted: "Sitoutunut",
    budgetSpent: "Käytetty", budgetAvailable: "Saatavilla",
    budgetPlaceholder: "esim. 500", budgetSaved: "Budjetti tallennettu!",
    budgetNone: "Ei budjettia asetettu", setBudget: "Aseta budjetti",
    budgetGeneral: "Yleiset kulut",
    memberSortLabel: "Järjestä jäsenet", memberSortRegDate: "Rekisteröintipäivä",
    memberSortName: "Nimi A-Z", memberSortBirthday: "Tuleva syntymäpäivä",
    photoOptional: "Kuva ei ole pakollinen",
    pendingLabel: "Odottaa", purchasedLabel: "Ostettu",
    wishluTab: "Oma Wishlu", groupsTab: "Ryhmät", profileTab: "Profiili",
  }
};

export function t(lang, key) { 
  return (translations[lang] || translations.en)[key] || key; 
}
